import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full gap-3',
    image: 'bg-blue-light h-15 w-15',
    content: 'flex w-full flex-col gap-2',
    name: 'flex flex-col',
    additionalInfo: 'flex justify-start gap-6',
    nameText: 'heading-m lg:heading-xl',
    link: 'heading-xs lg:heading-s flex items-center gap-2 hover:underline hover:underline-offset-4',
    starIcon: 'text-inactive size-6'
  },
  variants: {
    rating: {
      true: {
        starIcon: 'text-icon-star'
      }
    }
  }
});
